import React from 'react';

export default function PageTitle({title}) {
    return(
        <section className="text-center py-6">
            <h1>{title}</h1>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/PageTitle.js